import { PublicLayout } from "@components/layouts/PublicLayout";
import { RegisterView } from "@containers/login/RegisterView";

const RegisterPage = () => {
    return (
        <PublicLayout>
            <RegisterView />
        </PublicLayout>
    ) ;
}

export default RegisterPage ;